type HostParticipantLike = {
  metadata?: string | null;
};

export const isStartedLivestreamStatus = (status?: string | null) => {
  return status === 'LIVE' || status === 'COMPLETED';
};

export const isHostParticipantMetadata = (metadata?: string | null) => {
  if (!metadata) {
    return false;
  }

  try {
    return JSON.parse(metadata).isHost === true;
  } catch {
    return false;
  }
};

export const hasStartedViewerSession = (
  sessionStatus: string | null | undefined,
  participants: Iterable<HostParticipantLike>,
) => {
  if (isStartedLivestreamStatus(sessionStatus)) {
    return true;
  }

  for (const participant of participants) {
    if (isHostParticipantMetadata(participant.metadata)) {
      return true;
    }
  }

  return false;
};
